import { config } from "./Config";

export class JavascriptLoader {
    public static stripeInstance: stripe.Stripe;
    private static initPromise: Promise<stripe.Stripe> | undefined;

    public static load(url: string, identifier: string): Promise<void> {
        return new Promise((resolve, reject) => {
            const scriptLoad = document.createElement("script");
            scriptLoad.src = url;
            scriptLoad.className = identifier;

            scriptLoad.addEventListener(
                "load",
                () => {
                    resolve();
                },
                { once: true }
            );

            scriptLoad.addEventListener(
                "error",
                () => {
                    reject(new Error("Failed to load script"));
                },
                { once: true }
            );

            const old = document.head.getElementsByClassName(identifier);
            if (old.length > 0) old[0].remove();

            document.head.appendChild(scriptLoad);
        });
    }

    public static requireStripe(): Promise<stripe.Stripe> {
        if (JavascriptLoader.initPromise !== undefined) return JavascriptLoader.initPromise;

        const prom = new Promise<stripe.Stripe>((resolve, reject) => {
            if (JavascriptLoader.stripeInstance !== undefined) {
                resolve(JavascriptLoader.stripeInstance);
                return;
            }

            const scriptLoad = document.createElement("script");
            scriptLoad.src = "https://js.stripe.com/v3/";

            scriptLoad.addEventListener(
                "load",
                () => {
                    JavascriptLoader.stripeInstance = Stripe(config.stripePublicKey);
                    resolve(JavascriptLoader.stripeInstance);
                    JavascriptLoader.initPromise = undefined;
                },
                { once: true }
            );

            scriptLoad.addEventListener(
                "error",
                () => {
                    reject(new Error("Failed to load stripe script"));
                },
                { once: true }
            );

            document.head.appendChild(scriptLoad);
        });

        if (JavascriptLoader.stripeInstance === undefined) JavascriptLoader.initPromise = prom;

        return prom;
    }
}
